import { buildWhatsAppInquiryUrl } from "../lib/whatsapp";
import { MessageCircle, SnailIcon, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 bg-moss text-primary-foreground grain">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <h3 className="font-serif text-3xl mb-3">Lineacraft India</h3>
          <p className="text-sm opacity-80 leading-relaxed">
            Handcrafted leather &amp; cotton from Santiniketan — where every stitch carries a story.
          </p>
        </div>
        <div>
          <div className="overline opacity-70 mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/shop" className="opacity-90 hover:opacity-100">Shop All</a></li>
            <li><a href="/shop?cat=Leather%20Bags" className="opacity-90 hover:opacity-100">Leather Bags</a></li>
            <li><a href="/shop?cat=Cotton%20Bags" className="opacity-90 hover:opacity-100">Cotton Bags</a></li>
            <li><a href="/shop?cat=Accessories" className="opacity-90 hover:opacity-100">Accessories</a></li>
          </ul>
        </div>
        <div>
          <div className="overline opacity-70 mb-3">Reach us</div>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> Rabindra Pally, Bolpur, Birbhum</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> lineacraftindia@gmail.com</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> +91 8900658130</li>
            <li>
              <a href={buildWhatsAppInquiryUrl()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link"
                className="inline-flex items-center gap-2 mt-2 px-4 py-2 rounded-full bg-whatsapp text-white text-sm hover:opacity-90">
                <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="overline opacity-70 mb-3">Follow</div>
          <a href="https://www.facebook.com/share/1Aya7qM9wS/" className="inline-flex items-center gap-2 text-sm opacity-90 hover:opacity-100"><SnailIcon className="w-4 h-4" /> @lineacraft.in</a>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs opacity-60 flex flex-col sm:flex-row items-center justify-center gap-2">
        <span>© {new Date().getFullYear()} Lineacraft India. All rights reserved.</span>
        <span className="hidden sm:inline">•</span>
        <span data-testid="app-version-badge" className="bg-white/10 px-2 py-0.5 rounded text-[11px] font-mono tracking-wide">v1.0.4</span>
      </div>
    </footer>
  );
}
